'use client';

import useSWR from 'swr';
import {
  type PluginUpdateManifest,
  pluginUpdateManifestSchema,
} from '@/lib/plugin-updates/manifest-schema';
import { fetcherWithSchema } from '@/lib/utils';

/**
 * Fetches the served plugin update manifest. Returns undefined while
 * loading or when the request fails; callers fall back to the
 * build-time version constants so update UI keeps working.
 */
export function usePluginUpdateManifest(
  isEnabled = true,
): PluginUpdateManifest | undefined {
  const { data } = useSWR<PluginUpdateManifest>(
    isEnabled ? '/api/plugin-updates' : null,
    (url: string) => fetcherWithSchema(url, pluginUpdateManifestSchema),
    {
      revalidateOnFocus: false,
      dedupingInterval: 60_000,
    },
  );

  return data;
}
